import { render, staticRenderFns } from "./video-view.vue?vue&type=template&id=bea6d470&scoped=true&"
import script from "./video-view.vue?vue&type=script&lang=js&"
export * from "./video-view.vue?vue&type=script&lang=js&"
import style1 from "./video-view.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea6d470",
  null
  
)

export default component.exports